import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import TableComponent from "../../components/TableComponent";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const venueRows = [
  {
    id: 1,
    name: "Grand Hall",
    date: "2024-06-01",
    status: "Completed",
    amount: "$500",
  },
  {
    id: 2,
    name: "City Banquet",
    date: "2024-05-15",
    status: "Cancelled",
    amount: "$0",
  },
];
const venueColumns = [
  { field: "name", headerName: "Venue Name", flex: 1, minWidth: 150 },
  { field: "date", headerName: "Booking Date", flex: 1, minWidth: 150 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
];
const storageRows = [
  {
    id: 1,
    name: "Safe Storage 1",
    date: "2024-04-10",
    status: "Completed",
    amount: "$120",
  },
  {
    id: 2,
    name: "Locker Pro",
    date: "2024-03-22",
    status: "Ongoing",
    amount: "$80",
  },
];
const storageColumns = [
  { field: "name", headerName: "Storage Name", flex: 1, minWidth: 150 },
  { field: "date", headerName: "Booking Date", flex: 1, minWidth: 150 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
];

const AmenitiesDetails = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  // Booking History sub-tabs
  const [bookingTab, setBookingTab] = useState(0);
  const handleBookingTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setBookingTab(newValue);
  };

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>Category Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-customers")}>
              Manage Customers
            </span>{" "}
            - Customer Detail
          </p>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
            </div>
            <div className="gap_p">
              <div className="vew_img w_100">
                <h6>Image</h6>
                <figure>
                  <img alt="user" src="/static/images/user_placeholder.png" />
                </figure>
              </div>
              <div className="w_33">
                <h6>Name</h6>
                <p>Madelyn Dias</p>
              </div>
              <div className="w_33">
                <h6>Email Id</h6>
                <p>madelyndias@gmail.com</p>
              </div>
              <div className="w_33">
                <h6>Phone Number</h6>
                <p>9876543210</p>
              </div>
              <div className="w_33">
                <h6>Address</h6>
                <p>#123 Main Street, Downtown</p>
              </div>
              <div className="w_33">
                <h6>City</h6>
                <p>New York</p>
              </div>
              <div className="w_33">
                <h6>State</h6>
                <p>New York</p>
              </div>
              <div className="w_33">
                <h6>Country</h6>
                <p>New York</p>
              </div>
              <div className="w_33">
                <h6>Zip Code</h6>
                <p>98765</p>
              </div>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={bookingTab}
                onChange={handleBookingTabChange}
                aria-label="booking history tabs"
                className="custom_tabs_links"
              >
                <Tab label="Venue" />
                <Tab label="Storage" />
              </Tabs>
            </Box>
            <CustomTabPanel value={bookingTab} index={0}>
              <div className="sorting_table">
                <TableComponent columns={venueColumns} rows={venueRows} />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={bookingTab} index={1}>
              <div className="sorting_table">
                <TableComponent columns={storageColumns} rows={storageRows} />
              </div>
            </CustomTabPanel>
          </div>
        </CustomTabPanel>
      </MainContainer>
      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onSubmit={() => {}}
      />
    </>
  );
};

export default AmenitiesDetails;
